import React, { FC } from 'react';
import styled from 'styled-components';
import { MainContent } from 'src/pages-all/master-page/components/main-content';
import { SubSectionHeadline } from 'src/pages-all/home/components/parts/default.parts';
import { translate, translationKeys } from 'logic/translations/translations.service';
import { Text } from 'components/text/Text';
import { useBreakpoints } from 'logic/hooks/use-breakpoints';
import { MainLayout } from 'src/pages-all/master-page/components/main-layout';
import { CustomIcon } from 'components/custom-icon/CustomIcon';
import {
  CALENDAR2,
  CERTIFICATE,
  ELEARNING,
  SETTINGS,
  STEPS,
  SUCCESS,
  SWAP,
  WHITEBOARD,
} from 'assets/icons/icons';
import { bodyFontSize, highlightedBodyFontSize } from 'src/pages-all/home/home.page.const';
import { shadows } from 'styles/theme';
import { colors } from 'styles/colors';

const AdvantagesSection = styled(MainLayout)`
  padding: 0 12px;
  background-color: ${colors.lightTeal};
`;

const StyledMainContent = styled(MainContent)`
  border-radius: 30px;
  padding: 18px;
  box-shadow: ${shadows.shadow1};
  margin-bottom: 60px;
  background-color: white;
`;

const ContentBox = styled.div<{ mobile: boolean }>`
  margin: 60px auto;
  padding: ${({ mobile }) => (mobile ? '0' : '12px')};
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  gap: 30px;
`;

const ContentItem = styled.div`
  max-width: 320px;
  text-align: center;
`;

export const Advantages: FC<{ variant?: 'online-nachhilfe' }> = ({ variant }) => {
  const { maxMobileLarge } = useBreakpoints();

  const translation =
    variant === 'online-nachhilfe'
      ? translationKeys.homepage.advantagesV2
      : translationKeys.homepage.advantages;

  const advantages = [
    {
      icon: STEPS,
      translationKey: 'content1',
    },
    {
      icon: SUCCESS,
      translationKey: 'content2',
    },
    {
      icon: ELEARNING,
      translationKey: 'content3',
    },
    {
      icon: WHITEBOARD,
      translationKey: 'content4',
    },
    {
      icon: SWAP,
      translationKey: 'content5',
    },
    {
      icon: CERTIFICATE,
      translationKey: 'content6',
    },
    {
      icon: CERTIFICATE,
      translationKey: 'content7',
    },
    {
      icon: SETTINGS,
      translationKey: 'content8',
    },
    {
      icon: CALENDAR2,
      translationKey: 'content9',
    },
  ];

  return (
    <AdvantagesSection id={'vorteile'}>
      <StyledMainContent>
        <SubSectionHeadline
          headline={translate(translation.heading)}
          center
          noHeadlineColor
          level={2}
        />
        <ContentBox mobile={maxMobileLarge}>
          {advantages.map((advantage, idx) => (
            <ContentItem key={idx}>
              <CustomIcon src={advantage.icon} width={80} />
              <div>
                <Text size={highlightedBodyFontSize(maxMobileLarge)} fontWeight={700}>
                  {translate(translation.contents[advantage.translationKey].title)}
                </Text>
              </div>
              <div>
                <Text size={bodyFontSize(maxMobileLarge)}>
                  {translate(translation.contents[advantage.translationKey].description)}
                </Text>
              </div>
            </ContentItem>
          ))}
        </ContentBox>
      </StyledMainContent>
    </AdvantagesSection>
  );
};
